<div class="request-leave-dialog">
  <div class="dialog-header">
    <h2 class="dialog-title">Edit Leave Request</h2>
    <button mat-icon-button class="close-btn" (click)="onCancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Content -->
  <mat-dialog-content>
    <form [formGroup]="leaveForm" class="leave-form">

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>From Date</mat-label>
        <input
          matInput
          [matDatepicker]="fromPicker"
          formControlName="fromDate"
          [min]="today"
        >
        <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
        <mat-datepicker #fromPicker></mat-datepicker>
        <mat-error *ngIf="leaveForm.get('fromDate')?.hasError('required')">
          From Date is required.
        </mat-error>
        <mat-error *ngIf="leaveForm.get('fromDate')?.hasError('matDatepickerMin')">
          Past dates cannot be selected for a leave request.
        </mat-error>
      </mat-form-field>

      <!-- To Date -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>To Date</mat-label>
        <input
          matInput
          [matDatepicker]="toPicker"
          formControlName="toDate"
          [min]="leaveForm.get('fromDate')?.value"
        >
        <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
        <mat-datepicker #toPicker></mat-datepicker>
        <mat-error *ngIf="leaveForm.get('toDate')?.hasError('required')">
          To Date is required.
        </mat-error>
        <mat-error *ngIf="leaveForm.errors?.dateRangeInvalid">
          To Date must be after From Date.
        </mat-error>
      </mat-form-field>

      <!-- Leave Type -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Leave Type</mat-label>
        <mat-select formControlName="leaveType" required>
          <mat-option value="Sick">Sick</mat-option>
          <mat-option value="Holiday">Holiday</mat-option>
          <mat-option value="Personal">Personal</mat-option>
          <mat-option value="Vacation">Vacation</mat-option>
          <!-- <mat-option value="TimeOff">Time Off / PTO</mat-option> -->
        </mat-select>
        <mat-error *ngIf="leaveForm.get('leaveType')?.hasError('required')">
          Leave Type is required.
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Note</mat-label>
        <textarea matInput rows="2" placeholder="Type here" formControlName="notes" [maxlength]="notesMaxLength"></textarea>
        <mat-hint align="end">{{ leaveForm.get('notes')?.value?.length || 0 }}/{{ notesMaxLength }}</mat-hint>
        <mat-error *ngIf="leaveForm.get('notes')?.hasError('maxlength')">
          Note cannot exceed the maximum allowed length of {{ notesMaxLength }} characters.
        </mat-error>
      </mat-form-field>

    </form>
  </mat-dialog-content>

  <!-- Actions -->
  <mat-dialog-actions align="end" class="dialog-actions">
    <button mat-stroked-button class="cancel_btn" (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" (click)="onSave()">
      Update
    </button>
  </mat-dialog-actions>
</div>
